import STATES from '../app/constant/states';
import { APP_VERSION } from '../app/constant/version';
import { UIAdminEnvironment } from './environment.interface';

export const environment: UIAdminEnvironment = {
	home: 'https://rudevops.com',
	production: true,
	apiUrl: '', // We'll be using reverse proxy from Cloudfront
	states: STATES,
	stripe_api_key: 'pk_test_0WgUbxQ7lFquVeBjBB8cY4ld00jua9T2Dv',
	version: APP_VERSION,
	syncfusionLicense:
		'Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXtcd3ZURWdeVUZyXUVWYEo=',
};
